export default __webpack_public_path__ + "static/media/36I-114280_-20490_0.e8baa2fa.jpg";